import React from 'react';

const Button = ({ className, type, children, ...props }) => (
  <button className={`button${className ? ` ${className}` : ''}`} type={type} {...props}>
    {children}
  </button>
);

export default Button;
